import {useContext, useEffect, useRef} from "react";
import {ReducerStateInterface} from "./interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "./GlobalReducer";
import {mergeBasket} from "./api/customer";
import {LOCAL_STORAGE_KEY_BASKET, LOCAL_STORAGE_KEY_BASKET_LAST_UPDATE} from "./Config";
import {BasketItemInterface} from "./interfaces/core/BasketItemInterface";
import useInterval from "./utils/useInterval";

export default function BasketServerSync() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const previousBasketUidRef = useRef<string | null>(null);
    const lastUpdateTimestamp = useRef<number | null>(null);

    const updateBasket = (basket: BasketItemInterface[], forceUpdate = false) => {
        if (state.customer?.id && state.customer?.sign && window.document.hasFocus()) {
            mergeBasket(state.customer.id, state.customer.sign, basket, lastUpdateTimestamp.current || 0).then(basketResponse => {
                const currentBasketUid = basket.map(item => item.itemId + '-' + item.quantity + '-' + item.modelColorItem?.min_price?.amount).sort().join('|');
                const newBasketUid = basketResponse.basket?.map(item => item.itemId + '-' + item.quantity + '-' + item.modelColorItem?.min_price?.amount).sort().join('|');
                // console.log('State Basket ', basket.map(item => item.modelColorItem.articul + '-' + item.size + '-' + item.quantity).sort().join('|'), lastUpdateTimestamp.current)
                // console.log('Response Basket ', basketResponse.basket.map(item => item.modelColorItem.articul + '-' + item.size + '-' + item.quantity).sort().join('|'), basketResponse.timestamp)


                // console.log('-->>', currentBasketUid ,  newBasketUid,  currentBasketUid ===  newBasketUid)

                if (currentBasketUid !== newBasketUid) {

                    const basketFromResponse = basketResponse.basket.filter(item => !!item.modelColorItem)

                    dispatch({
                        type: ReducerActionType.SET_BASKET,
                        payload: basketFromResponse
                    });
                    previousBasketUidRef.current = currentBasketUid;
                    lastUpdateTimestamp.current = basketResponse.timestamp;
                    console.log('Basket Updated', basketFromResponse)
                }

            });
        }
    };

    useEffect(() => {
        if (state.basket.length > 0) {
            // updateBasket(state.basket);
            lastUpdateTimestamp.current = Math.floor((new Date().getTime()) / 1000);
        }
    }, [state.basket]);

    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY_BASKET_LAST_UPDATE, lastUpdateTimestamp.current?.toString() || '0');
    }, [lastUpdateTimestamp.current]);

    // Properly handle the window focus event
    useEffect(() => {
        lastUpdateTimestamp.current = parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_BASKET_LAST_UPDATE)|| '0') ;

        const handleFocus = () => {
            dispatch({
                type: ReducerActionType.SET_BASKET,
                payload: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_BASKET) || '[]')
            });
        };

        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    useInterval(() => {
        updateBasket(state.basket,true);
    }, 10000);

    return (<></>);
}